module.exports = __webpack_public_path__ + "media/images/category_icons/services-c9d0f96a273d9c37586a330b0c426845.svg";